import { StatusBadgeConfig } from "../component-configs/status-badge";

export class ParsedSequence {
  noSequence?: boolean;
  credit: string;
  date: string;
  legs: string;
  layovers: string;
  reasonCode: string;
  reasonDescription: string;
  sequence: string | number;
  state: StatusBadgeConfig;
  seat: string;
  originate: {
    date: string;
    time: string;
  };
  terminate: {
    date: string;
    time: string;
  };

  constructor(data?: Partial<ParsedSequence>) {
    this.noSequence = data?.noSequence || false;
    this.credit = data?.credit || "00:00";
    this.date = data?.date || "";
    this.legs = data?.legs || "";
    this.layovers = data?.layovers || "";
    this.reasonCode = data?.reasonCode || "N/A";
    this.reasonDescription = data?.reasonDescription || "Not Available";
    this.sequence = data?.sequence || 0;
    this.state = data?.state || { class: "status loading", icon: "pi pi-spin pi-sync", text: "Loading" };
    this.seat = data?.seat || "FO";
    this.originate = data?.originate || { date: "", time: "" };
    this.terminate = data?.terminate || { date: "", time: "" };
  }
}

// export class ParsedSequence {
//   date: string;
//   sequenceNumber: string;
//   status: SequenceStatus;
//   state: SequenceState;
//   sequenceTimes: SequenceTimes;
//   additionalPay: AdditionalPay;
//   originate: {
//     date: string;
//     localTime: string;
//     utcTime: string;
//   };
//   terminate: {
//     date: string;
//     localTime: string;
//     utcTime: string;
//   };
//   layovers: string;
//   legs: string;

//   constructor(data?: Partial<ParsedSequence>) {
//     this.date = data?.date || "";
//     this.sequenceNumber = data?.sequenceNumber || "";
//     this.status = data?.status || { base: "", seat: "", equipment: "" };
//     this.state = data?.state || { class: "status loading", icon: "pi pi-spin pi-sync", text: "Loading" };
//     this.sequenceTimes = data?.sequenceTimes || { tafb: "", sequenceGreater: "", payCredit: "", sequenceTotal: "" };
//     this.additionalPay = data?.additionalPay || { afterMidnight: "", extraDay: "" };
//     this.originate = data?.originate || { date: "", localTime: "", utcTime: "" };
//     this.terminate = data?.terminate || { date: "", localTime: "", utcTime: "" };
//     this.layovers = data?.layovers || "";
//     this.legs = data?.legs || "";
//   }
// }

export interface SequenceState {
  class: string;
  icon: string;
  text: string;
}

export interface SequenceStatus {
  base: string;
  seat: string;
  equipment: string;
}

export interface SequenceTimes {
  tafb: string;
  sequenceGreater: string;
  payCredit: string;
  sequenceTotal: string;
}

export interface AdditionalPay {
  afterMidnight: string;
  extraDay: string;
}
